import { Record, Map as ImmutableMap } from 'immutable';
import * as WorkflowManagementFeatureKeys from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import FeaturePermission, { ACCESS, REASON } from 'automation-ui-permissions/feature-permissions/records/FeaturePermission';
export default class FeaturePermissions extends Record({
  [WorkflowManagementFeatureKeys.ASSIGN_TEAM]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.CLONE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.COMMENT]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.DELETE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.DISABLE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_ACTIONS]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_DESCRIPTION]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_ENROLLMENT]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_REENROLLMENT]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_SETTINGS]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.ENABLE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EXPORT]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.MANUAL_ENROLLMENT]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.MOVE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.RESTORE]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.EDIT_GOAL]: new FeaturePermission(),
  [WorkflowManagementFeatureKeys.TEST]: new FeaturePermission()
}, 'FeaturePermissions') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap.map(featurePermission => new FeaturePermission({
      [ACCESS]: featurePermission.access,
      [REASON]: featurePermission.reason
    })));
  }
  getFeaturePermission(feature) {
    return this.get(feature);
  }
}